<!-- 封装表格组件 -->
<template>
  <el-table
    ref="tableRef"
    :height="height"
    :data="data"
    style="width: 100%; height: 100%"
    :style="{ minHeight: minHeight }"
    :max-height="maxHeight"
    v-loading="loading"
    :show-summary="showSummary"
    :summary-method="getSummaries"
    :lazy="lazy"
    :load="load"
    :row-key="getRowKey"
    :row-style="rowColor"
    border
    :infinite-scroll-distance="10"
    v-el-table-infinite-scroll="handleScrollSearch"
    @expand-change="handleExpandChange"
    @sort-change="handleSortChange"
    @header-dragend="handleHeaderDragend"
    @selection-change="onSelectChange"
    @select="handleSelect"
  >
    <!-- 是否可以展开 显示子表格-->
    <el-table-column v-if="isExpand" type="expand" label="·">
      <template #default="{ row, column, index }">
        <el-card class="ml5 mt10 mb20" shadow="hover">
          <Table
            :height="300"
            :data="row.childTableData ? row.childTableData : []"
            :rowKey="childRowKey"
            height="100%"
            minHeight="10px"
            :isSelect="isSelect"
            :columns="childColumns"
            :loading="row.childTableLoading"
            @onSearch="handleSearch(row)"
          />
        </el-card>
      </template>
    </el-table-column>

    <!-- 单选 -->
    <el-table-column v-if="isSelect && isRadio" width="38">
      <template #default="{ row, column, index }">
        <el-radio-group v-model="radioValue" @change="handelRadioChange(row)">
          <el-radio :value="row[rowKey]" />
        </el-radio-group>
      </template>
    </el-table-column>
    <!-- 多选 -->
    <el-table-column v-if="isSelect && !isRadio" type="selection" width="38" />
    <!-- 序号 -->
    <el-table-column v-if="showIndex" type="index" width="51" label="序号" />

    <el-table-column
      v-for="(item, index) in columns"
      :key="item.prop"
      :prop="item.prop"
      :label="item.label"
      :fixed="item.fixed"
      :width="item.itemWidth"
      :min-width="item.noMinWidth ? '' : item.minWidth"
      :resizable="tableName ? true : false"
      :sortable="getSortStatus(item.sort)"
      :show-overflow-tooltip="item.tooltip"
    >
      <!-- 表头文字 -->
      <template #header="{ column, $indfex }">
        <span class="thead-cell"></span>
        <span class="text-cell">
          {{ column.label }}
        </span>
      </template>
      <!-- 字典 -->
      <template #default="{ row }" v-if="item.type === 'dict'">
        <span
          :style="{
            color:
              searchTextDict &&
              item.prop in searchTextDict &&
              row[item.prop] === searchTextDict[item.prop]
                ? 'red'
                : '',
          }"
        >
          {{ getDictNameByPCodeSCode(item.dictKey, row[item.prop]) }}
        </span>
      </template>
      <!-- 仓库 -->
      <template #default="{ row }" v-else-if="item.type === 'warehouse'">
        {{ getWarehouseNameById(row[item.prop]) }}
      </template>
      <!-- 根据缓存获取值 -->
      <template #default="{ row }" v-else-if="item.type === 'cache'">
        {{
          getCacheValue(
            item.cacheKey,
            item.cacheCode,
            item.cacheValue,
            row[item.prop],
          )
        }}
      </template>
      <template #default="{ row }" v-else-if="item.type === 'input'">
        <el-input
          v-if="item.propType == 'number'"
          :input-style="{
            color:
              row[item.prop] != row[item.compareProp] ? '#ff0000' : '#000000',
          }"
          type="number"
          v-model="row[item.prop]"
          @input="
            row[item.prop] = row[item.prop].replace(/^0+(\d)|[^\d]+/g, '')
          "
          clearable
          :disabled="
            row.productId && row.usageType !== '1' && !disabledBtn
              ? false
              : true
          "
          @change="changeInput(row)"
        />
        <el-input
          v-else
          v-model="row[item.prop]"
          clearable
          @change="changeInput(row)"
        />
      </template>
      <template #default="{ row }" v-else-if="item.type === 'select'">
        <el-select
          :disabled="disabledBtn"
          v-model="row[item.prop]"
          placeholder="请选择"
          @change="changeSelect(row)"
        >
          <el-option
            v-for="(item1, index) in getDictListByParentCode(item.dictKey)"
            :key="item1.libraryId + index"
            :label="item1.libraryName"
            :value="item1.libraryCode"
            :disabled="item1.disabled"
          />
        </el-select>
      </template>
      <!-- 图片 -->
      <template #default="{ row }" v-else-if="item.type === 'img'">
        <template v-if="row[item.prop]">
          <el-image
            style="width: 100px; height: 100px"
            :src="getCosFileUrl(row[item.prop])"
            :zoom-rate="1.2"
            :max-scale="7"
            :min-scale="0.2"
            :preview-src-list="[row[item.prop]]"
            :initial-index="0"
            fit="cover"
            :preview-teleported="true"
          >
            <template #placeholder>
              <div class="image-slot"></div>
            </template>
          </el-image>
        </template>
        <template v-else>
          <div class="image-slot"></div>
        </template>
      </template>
      <template
        #default="{ row, column, $index }"
        v-else-if="item.type === 'renderHtml'"
      >
        <div v-html="item.renderHtml(row, column, index)"></div>
      </template>
      <!-- 操作列 -->
      <template
        #default="{ row, column, index }"
        v-else-if="item.type === 'action'"
      >
        <template
          v-for="action_item in item.action"
          :key="action_item.controlPermission"
        >
          <template v-if="action_item.control === 'button'">
            <el-button
              :link="action_item.controlType == 'text' ? true : false"
              type="primary"
              :key="action_item.controlPermission"
              :text="action_item.controlText"
              :disabled="
                action_item.controlDisabled
                  ? action_item.controlDisabled(row, column, index)
                  : false
              "
              @click="action_item.controlFun($event, row, column, index)"
              v-hasPermi="action_item.controlPermission"
            >
              {{ action_item.controlName }}
            </el-button>
          </template>
        </template>
      </template>
      <template #default="{ row }" v-else>
        <template v-if="searchTextDict && item.prop in searchTextDict">
          <span
            v-html="onSearchTextRed(row[item.prop], searchTextDict[item.prop])"
          >
          </span>
        </template>
        <template v-else>
          <template v-if="item.textColor">
            <span :style="{ color: item.textColor }">
              {{ row[item.prop] }}
            </span>
          </template>
          <template v-else>
            {{ row[item.prop] }}
          </template>
        </template>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup>
import { onMounted, ref, watch, nextTick } from "vue";
import useCacheStore from "@/store/modules/cache";
import Sortable from "sortablejs";
import { getCosFileUrl } from "@/utils/fangerUtils";

/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "Table",
});
const cacheStore = useCacheStore();

const {
  getDictNameByPCodeSCode,
  getWarehouseNameById,
  getDictListByParentCode,
  getCacheValue,
} = cacheStore;

const emits = defineEmits([
  "expandOpen",
  "search",
  "scrollSearch",
  "saveCol",
  "changeSelect",
  "changeInput",
  "onSelectChange",
  "updateColOrder",
]);

const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  columns: {
    type: Array,
    default: () => [],
  },
  height: {
    // 表格高度
    type: [Number, String],
    default: "500px",
  },
  /* 最小高度 */
  minHeight: {
    type: [Number, String],
    default: "10px",
  },
  maxHeight: {
    type: [Number, String],
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  lazy: {
    type: Boolean,
    default: false,
  },
  load: {
    type: Function,
    default: () => {},
  },
  rowKey: {
    // 行 key
    required: false,
    type: String,
    default: "",
  },
  rowKeyUnique: {
    // rowkey 是否唯一，不唯一的情况下，使用增加随机数保证key 唯一
    type: Boolean,
    default: false,
  },
  showIndex: {
    // 是否显示序号
    type: Boolean,
    default: true,
  },
  isSelect: {
    // 是否可以选择
    type: Boolean,
    default: true,
  },
  isRadio: {
    // 是否为单选
    type: Boolean,
    default: false,
  },
  isExpand: {
    // 是否可以展开
    type: Boolean,
    default: false,
  },
  childColumns: {
    // 可以展开子表格的类数据
    type: Array,
    default: () => [],
  },
  getChildDataFun: {
    type: Function,
    default: () => {},
  },
  childRowKey: {
    required: false,
    type: String,
    default: "",
  },
  disabledBtn: {
    // 输入、选择、按钮是否disabled
    type: Boolean,
    default: false,
  },
  searchText: {
    required: false,
    type: String,
    default: "",
  },
  sortable: {
    // 是否可以排序表格
    type: [Boolean, String],
    default: "custom",
  },
  tableName: {
    // 表格的名字
    required: false,
    type: String,
    default: "",
  },
  /* 搜索文字 */
  searchTextDict: {
    type: Object,
    default: () => {},
  },
  /* 展示合计行 */
  showSummary: {
    type: Boolean,
    default: false,
  },
  /* 合计属性 */
  summaryProperty: {
    type: String,
    default: "",
  },
  /* 无限滚动搜索 */
  infiniteScroll: {
    type: Boolean,
    default: false,
  },
});

/**
 * 获取排序状态
 */
const getSortStatus = (itemSort) => {
  if (props.infiniteScroll) {
    return false;
  } else if (props.sortable && itemSort) {
    return props.sortable;
  } else {
    return true;
  }
};

const getRowKey = (row) => {
  if (!props.rowKeyUnique) {
    if (row[props.rowKey]) {
      return row[props.rowKey] + props.data.indexOf(row);
    }
  } else {
    return row[props.rowKey];
  }
};

const getSummaries = (param) => {
  const { columns, data } = param;
  const sums = [];
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = "合计";
      return;
    }
    if (column.property !== props.summaryProperty) return;
    const values = selectVals.value.map((item) =>
      Number(item[column.property]),
    );
    if (!values.every((value) => isNaN(value))) {
      sums[index] = values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0);
      sums[index];
    } else {
      sums[index] = "---";
    }
  });
  return sums;
};
const tableRef = ref(null);
const radioValue = ref("");
let radioSelectData = null;
// 刷新懒加载数据
const reLazyLoad = (data) => {
  if (tableRef.value.store.states.treeData.value[data[props.rowKey]]) {
    tableRef.value.store.states.treeData.value[
      data[props.rowKey]
    ].loaded = false;
  } else {
    tableRef.value.store.states.treeData.value[data[props.rowKey]] = {
      children: [],
      lazy: true,
      level: 0,
      expanded: false,
      loaded: false,
      loading: false,
      display: true,
    };
  }
  tableRef.value.store.loadOrToggle(data);
};

// 根据单元格文本删除节点
const removeRowByEvent = (event) => {
  const elTable = tableRef.value.$el.querySelector("tbody");
  const rowElement = getRowElement(event.target);
  elTable.removeChild(rowElement);
};

const getRowElement = (event) => {
  if (event.organName !== "TR") {
    return getRowElement(event.parentElement);
  } else {
    return event;
  }
};

let curExpandedRowKeys = [];
// 展开行
const handleExpandChange = (row, expandedRows) => {
  if (props.isExpand && expandedRows instanceof Array) {
    curExpandedRowKeys = expandedRows;
    if (expandedRows.includes(row)) {
      emits("expandOpen", row);
    }
  }
};

let sortParams = null;

// 排序
const handleSortChange = ({ column, prop, order }) => {
  if (props.sortable === "custom") {
    if (order === "descending") {
      sortParams = [{ column: prop, querLogic: "DESC" }];
    } else if (order === "ascending") {
      sortParams = [{ column: prop, querLogic: "ASC" }];
    } else {
      sortParams = null;
    }

    emits("search");
  }
};

const tableCol = ref();
// 调整列宽
const handleHeaderDragend = (newWidth, oldWidth, column, event) => {
  if (newWidth < column.minWidth) {
    column.width = column.minWidth;
  }
  tableCol.value = props.columns;
  tableCol.value.forEach((item) => {
    if (item.prop === column.property) {
      item.itemWidth =
        item.itemMinWidth > column.width
          ? item.itemMinWidth
          : column.width.toFixed(2);
    }
  });

  emits("saveCol");
};
const selectVals = ref([]);
// 选择改变回调函数
const onSelectChange = (vals) => {
  selectVals.value = vals;
  emits("onSelectChange", vals);
};

// 表格多选框单个选择项改变事件
const handleSelect = (vals, row) => {
  // console.log(vals, row);
};

const rowColor = (row) => {
  if (row.row.returnInWarehouse == "1") {
    return {
      backgroundColor: "#e9c25a80",
    };
  }
};

// 获取搜索参数
const getSortParams = () => {
  if (sortParams === null) {
    return null;
  } else {
    return JSON.stringify(sortParams);
  }
};

const handleSearch = (row) => {
  console.log("row1", row);
};

const changeSelect = (row) => {
  emits("changeSelect", row);
};
const changeInput = (row) => {
  emits("changeInput", row);
};

/**
 * 单选改变
 */
const handelRadioChange = (row) => {
  radioSelectData = row;
};

/**
 * 获取选中的行
 */
const getSelectedRows = () => {
  if (props.isRadio) {
    return radioSelectData;
  } else {
    return tableRef.value.getSelectionRows();
  }
};

// 设置搜索字符为红色
const onSearchTextRed = (val, searchText) => {
  if (val === undefined || val === null) return val;
  if (val.indexOf(searchText) !== -1 && searchText !== "") {
    return val.replace(
      searchText,
      '<span style="color:red;">' + searchText + "</span>",
    );
  } else {
    return val;
  }
};

/**
 * 清除选择
 */
const cleanSelect = () => {
  if (props.isRadio) {
    radioValue.value = "";
    radioSelectData = null;
  } else {
    tableRef.value.clearSelection();
  }

  if (curExpandedRowKeys.length > 0) {
    curExpandedRowKeys.forEach((item) => {
      tableRef.value.toggleRowExpansion(item, false);
    });
  }
};

/**
 * 滚动搜索
 */

const handleScrollSearch = () => {
  if (props.infiniteScroll) {
    emits("scrollSearch");
  }
};

onMounted(() => {
  // 生成可以配置的列开头是第几列
  let startColIndex = 0;
  if (props.isExpand) {
    startColIndex += 1;
  }
  if (props.isSelect) {
    startColIndex += 1;
  }
  if (props.showIndex) {
    startColIndex += 1;
  }
  watch(
    () => props.data,
    (newVal) => {
      cleanSelect();
    },
  );
  watch(
    () => props.columns,
    (newVal) => {
      if (newVal.length > 0) {
        nextTick(() => {
          const headerWrapper =
            tableRef.value.$refs.headerWrapper.querySelector("tr");
          Sortable.create(headerWrapper, {
            onEnd: (evt) => {
              const { oldIndex, newIndex } = evt;
              if (oldIndex === newIndex) {
                return;
              }
              const dragCol = props.columns[oldIndex - startColIndex];
              const endCol = props.columns[newIndex - startColIndex];
              // 是否为倒序
              let reverseOrder = false;
              if (oldIndex > newIndex) {
                reverseOrder = true;
              }
              emits("updateColOrder", {
                reverseOrder: reverseOrder, // 是否为倒序
                dragCol: dragCol.prop, // 拖拽列
                endCol: endCol.prop, // 结束列
              });
            },
          });
        });
      }
    },
  );
});

defineExpose({
  reLazyLoad,
  removeRowByEvent,
  getSelectedRows,
  cleanSelect,
  getSortParams,
  // 获取table ref
  getTableRef: () => {
    return tableRef.value;
  },
});
</script>

<style lang="scss" scoped>
// 表头设置
:deep(th) {
  // cursor: move;
  -moz-user-select: none; /*firefox*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*ie10+*/
  -khtml-user-select: none; /*早期的浏览器*/
  user-select: none; /*文字不能被选中*/
  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    :nth-child(1) {
      text-align: center;
      white-space: pre-wrap;
    }
  }
}
.image-slot {
  text-align: center;
}
:deep(.text-cell) {
  cursor: pointer;
  position: relative;
  z-index: 10;
}
</style>
